import styled from "styled-components";
import Theme from "../Theme/Theme";

export const StyledFilters = styled.div`
    width: 15em;
    height: 80vh;
    background-color: #E6EDF0;
    display: flex;
    flex-direction: column;
    

ul{
    height: auto;
    padding: 0;
    width: 100%;
}

li{
    width: 100%;
    margin-bottom: 8%;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    color: #222222;
    padding-left: 1em;
    align-items: center;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
    
`;

export const PageContent = styled.div`
    position: relative;
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    //padding: 0 0 ${Theme.spacing['s12']};
    width: 100%;
    height: ${props => (props.$height ?? null)};
    margin: ${props => props.$margin ?? 0};
    padding: ${props => props.$padding ?? 0};
`;
export const PageTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent; 

    .title { 
        display: flex;
        align-items: center;
    }

    .filters {
        display:flex;
        .ant-select {
            margin-left: ${Theme.spacing['s07']};
        }
    }
   
`;

export const PageSection = styled.div`
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    padding: ${props => (props.$padding ? props.$padding : `${Theme.spacing['s06']} ${Theme.spacing['s08']}`)};
    display: ${props => (props.$display === 'false' ? 'none' : null)};
    padding-bottom: ${props => (props.$paddingBottom ? props.$paddingBottom : null)};

    &.first-section{
        padding-top: 0;
    }
`;

export const PageHeader = styled.div`
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    padding: 0 ${Theme.spacing['s08']};

    &.map {
        padding: ${Theme.spacing['s05']} ${Theme.spacing['s08']} 0;
    }
`;

export const PageFilters = styled.div`
    display:flex;
    margin: ${Theme.spacing['s05']} 0;
    .ant-select {
        margin-left: ${Theme.spacing['s07']};
    }
    float: right;
`;

export const AnchorSection = styled.div`
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    padding: ${Theme.spacing['s04']} ${Theme.spacing['s08']};
`;

export const Field = styled.div`
    font-family: ${Theme.typography.fontFamily};
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    padding: ${Theme.spacing['s04']} ${Theme.spacing['s05']};
    border-radius: ${Theme.radius.md};
`;
export const StickyButtons = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    font-family: ${Theme.typography.fontFamily};
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s08']};
`;
